"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeofenceRule = void 0;
const ModelCommon_1 = require("./ModelCommon");
const debug = !process.env.AWS_SESSION_TOKEN && false;
const typeId = 'GeofenceRule';
class GeofenceRule extends ModelCommon_1.ModelCommon {
    constructor(ob) {
        super(typeId, ob);
        this.enabled = ob.enabled;
        this.allowed = ob.allowed;
        this.geofence = ob.geofence;
        if (ob) {
            const userAttDefs = this.getUserAttributes();
            Object.entries(userAttDefs).forEach(([key, def]) => {
                if (def && Object.getOwnPropertyDescriptor(def, 'default') && ob[key] === undefined) {
                    this[key] = def.default;
                }
            });
        }
    }
    isSaveable() {
        return false;
    }
    getUserAttributes() {
        return {
            name: { type: 'String' },
            description: { type: 'String' },
            enabled: { type: 'Boolean', default: false },
            allowed: {
                type: 'Boolean',
                default: false,
                label: (currentSetting) => currentSetting === true ? 'Permitted in this area, alert if outside' : 'Prohibited in this area, alert if inside',
            },
            geofence: {
                type: 'Derived',
                valueFn: (state, functions, accessKey) => {
                    debug &&
                        console.log(`GeofenceRule valueFunction with geofence ${this.geofence ? this.geofence.id : 'no geofence'} and ids of Geofences available`, state.userView.Geofence.map((g) => g.id));
                    const geofence = this.geofence && this.geofence.id ? (state.userView?.Geofence).find((geofence) => (geofence.id = this.geofence?.id)) : undefined;
                    debug && console.log(`GeofenceRule valueFunction returning`, geofence);
                    //parentObject, attKey, parentKey
                    return { geofence, functions, parentObject: this, attKey: 'geofence', parentKey: accessKey };
                },
                viewName: 'GeofenceDetails',
            },
            failMessage: { type: 'String' },
        };
    }
}
exports.GeofenceRule = GeofenceRule;
